<div class="insurance" *ngIf="insurance?.code || loading()">
  <lx-card-container
    type="insurance"
    i18n-title
    title="Protect your trip"
    [loading]="loading()"
    [actionMode]="selectedInsuranceCode ? 'remove' : 'add'"
    [disabled]="!!!selectedInsuranceCode"
    [endPrice]="endPrice"
    [price]="price"
    [currency]="currency?.()"
    [discount]="discount"
    (buttonClick)="addRemoveInsurance(insurance.code)"
    [gaEventName]="dataLayerEventName$ | async"
    [attr.data-qa]="'insurance_header'"
  >
    <div class="insurance__paragraph" i18n>Choose our medical and travel insurance for peace of mind during your stay!</div>
    <div class="insurance__paragraph" i18n>The price below is a guide. A Sales Advisor will confirm pricing and details to suit your needs.</div>
    <div class="card-container-highlighted" *ngIf="selectedInsuranceCode">{{ duration | lxLocalizeAndPluralizePeriod }}</div>
  </lx-card-container>
</div>
